var exports = {
  "fK": "x234b8571--28835c--fact",
  "h_": "x234b8571--28835c--description",
  "DD": "x234b8571--28835c--title",
  "Qq": "x234b8571--28835c--text",
  "pq": "x234b8571--28835c--info",
  "iZ": "x234b8571--28835c--inner-info",
  "Ks": "x234b8571--28835c--tooltip-text",
};

module.exports = exports;
